// export const BaseUrl = 'https://twinscart.com:8000'

export const BaseUrl = 'https://twinscart.com:8000'


export const token = localStorage.getItem("token");
